module.exports = "../dist/img/img_2-18.5305.jpg";